import React, { Component } from "react";
import { Input, Row, Col, Button } from "antd";
import _ from "lodash";
import MrTranslate from "lib/MrTranslate/MrTranslate";

class ProgrammeCustomInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      children: [],
      componentList: [],
      cList: [],
    };
  }

  componentDidMount() {
    if (typeof this.props.value === "string") {
      let listToPush = [];
      const objToPush = {
        id: 0,
        name: "",
        type: "",
        code: "",
        children: [],
      };
      listToPush.push(objToPush);
      this.setState(
        {
          children: listToPush,
        },
        () => {
          let list = [];
          for (const key in this.state.children) {
            const objectPerms = this.state.children[key];
            let input;
            var obj = {};
            for (const index in objectPerms) {
              input = (
                <Input
                  defaultValue={objectPerms[index]}
                  id={index}
                  onChange={(event) =>
                    this.customOnChange(event, objectPerms, null, index, null)
                  }
                />
              );
              obj[index] = input;
            }
            list.push(obj);
          }
          this.setState({
            componentList: list,
          });
        }
      );
    } else {
      const newList = [];
      const values = this.props.value;
      for (var v = 0; v < values.length; v++) {
        const currentElement = values[v];
        currentElement.id = v;
        for (const index in currentElement) {
          if (_.isArray(currentElement[index])) {
            for (var i = 0; i < currentElement[index].length; i++) {
              const current = currentElement[index][i];
              current.id = i;
            }
          }
        }
        newList.push(currentElement);
      }
      this.setState(
        {
          children: newList,
        },
        () => {
          let list = [];

          for (var key = 0; key < this.state.children.length; key++) {
            const objectPerms = this.state.children[key];
            // console.log("checking==>", objectPerms);
            const obj = {};
            obj["id"] = key;
            let input;
            let nestedInput;
            let nestedObj = {};
            const nestedList = [];
            for (const index in objectPerms) {
              if (_.isArray(objectPerms[index])) {
                for (var i = 0; i < objectPerms[index].length; i++) {
                  const current = objectPerms[index][i];
                  nestedObj["id"] = i;
                  for (const nestedIndex in current) {
                    nestedInput = (
                      <Input
                        defaultValue={current[nestedIndex]}
                        id={nestedIndex}
                        onChange={(event) =>
                          this.customOnChange(
                            event,
                            objectPerms,
                            current,
                            index,
                            nestedIndex
                          )
                        }
                      />
                    );
                    nestedObj[nestedIndex] = nestedInput;
                  }
                  nestedList.push(nestedObj);
                  nestedObj = {};
                }
                obj["children"] = nestedList;
              } else {
                input = (
                  <Input
                    defaultValue={objectPerms[index]}
                    id={index}
                    onChange={(event) =>
                      this.customOnChange(event, objectPerms, null, index, null)
                    }
                  />
                );

                obj[index] = input;
              }
            }
            list.push(obj);
            // console.log("checking==>", list);
          }
          this.setState({
            componentList: list,
          });
        }
      );
    }
  }

  customOnChange = (event, parentObj, childObj, id, nestedId) => {
    if (nestedId !== null) {
      const parentId = parentObj.id;
      const childId = childObj.id;
      const stateObj = [...this.state.children];
      stateObj[parentId][id][childId][event.target.id] = event.target.value;
      this.setState(
        {
          children: stateObj,
        },
        () => {
          this.props.onChange(this.state.children);
        }
      );
    } else {
      const parentId = parentObj.id;
      const stateObj = [...this.state.children];
      stateObj[parentId][event.target.id] = event.target.value;
      console.log("checking==>", stateObj);
      this.setState(
        {
          children: stateObj,
        },
        () => {
          this.props.onChange(this.state.children);
        }
      );
    }
    // this.state.children[id][event.target.id] = event.target.value;
    // this.props.onChange(JSON.stringify(this.state.children));
  };

  appendChild = () => {
    const newId = this.state.children.length;
    const objToPush = {
      id: newId,
      name: "",
      type: "",
      code: "",
      children: [],
    };
    this.setState(
      {
        children: [...this.state.children, objToPush],
      },
      () => {
        let list = [];

        for (var key = 0; key < this.state.children.length; key++) {
          const objectPerms = this.state.children[key];
          // console.log("checking==>", objectPerms);
          const obj = {};
          obj["id"] = key;
          let input;
          let nestedInput;
          let nestedObj = {};
          const nestedList = [];
          for (const index in objectPerms) {
            if (_.isArray(objectPerms[index])) {
              for (var i = 0; i < objectPerms[index].length; i++) {
                const current = objectPerms[index][i];
                nestedObj["id"] = i;
                for (const nestedIndex in current) {
                  nestedInput = (
                    <Input
                      defaultValue={current[nestedIndex]}
                      id={nestedIndex}
                      onChange={(event) =>
                        this.customOnChange(
                          event,
                          objectPerms,
                          current,
                          index,
                          nestedIndex
                        )
                      }
                    />
                  );
                  nestedObj[nestedIndex] = nestedInput;
                }
                nestedList.push(nestedObj);
                nestedObj = {};
              }
              obj["children"] = nestedList;
            } else {
              input = (
                <Input
                  defaultValue={objectPerms[index]}
                  id={index}
                  onChange={(event) =>
                    this.customOnChange(event, objectPerms, null, index, null)
                  }
                />
              );

              obj[index] = input;
            }
          }
          list.push(obj);
          // console.log("checking==>", list);
        }
        this.setState({
          componentList: list,
        });
      }
    );
  };
  addNestedChild = (obj) => {
    const id = obj.id.props.defaultValue;
    const newObjId = obj.hasOwnProperty("children") ? obj.children.length : 0;

    const objToPush = {
      id: newObjId ? newObjId : 0,
      name: "",
      type: "",
      code: "",
    };

    const stateObj = [...this.state.children];

    if (stateObj[id].hasOwnProperty("children")) {
      stateObj[id]["children"].push(objToPush);
    } else {
      stateObj[id]["children"] = [];
      stateObj[id]["children"].push(objToPush);
    }

    this.setState(
      {
        children: stateObj,
      },
      () => {
        let list = [];
        for (var key = 0; key < this.state.children.length; key++) {
          const objectPerms = this.state.children[key];
          const obj = {};
          obj["id"] = key;
          let input;
          let nestedInput;
          let nestedObj = {};
          const nestedList = [];
          for (const index in objectPerms) {
            if (_.isArray(objectPerms[index])) {
              for (var i = 0; i < objectPerms[index].length; i++) {
                const current = objectPerms[index][i];
                nestedObj["id"] = i;
                for (const nestedIndex in current) {
                  nestedInput = (
                    <Input
                      defaultValue={current[nestedIndex]}
                      id={nestedIndex}
                      onChange={(event) =>
                        this.customOnChange(
                          event,
                          objectPerms,
                          current,
                          index,
                          nestedIndex
                        )
                      }
                    />
                  );
                  nestedObj[nestedIndex] = nestedInput;
                }
                nestedList.push(nestedObj);
                nestedObj = {};
              }
              obj["children"] = nestedList;
            } else {
              input = (
                <Input
                  defaultValue={objectPerms[index]}
                  id={index}
                  onChange={(event) =>
                    this.customOnChange(event, objectPerms, null, index, null)
                  }
                />
              );

              obj[index] = input;
            }
          }
          list.push(obj);
          // console.log("checking==>", list);
        }
        this.setState({
          componentList: list,
        });
      }
    );
  };
  render() {
    return (
      <>
        {JSON.stringify(this.state.children)}
        {this.state.componentList
          ? this.state.componentList.map((child) => (
              <>
                <Row gutter={16}>
                  {child.hasOwnProperty("name") ? (
                    <Col span={8}>{child.name}</Col>
                  ) : (
                    <Col span={8}></Col>
                  )}
                  {child.hasOwnProperty("type") ? (
                    <Col span={8}>{child.type}</Col>
                  ) : (
                    <Col span={8}></Col>
                  )}
                  {child.hasOwnProperty("code") ? (
                    <Col span={6}>{child.code}</Col>
                  ) : (
                    <Col span={6}></Col>
                  )}
                  <Col span={2}>
                    <Button onClick={() => this.addNestedChild(child)}>
                      <MrTranslate id={"ProgrammeCustomInput.add_nested"}/>
                    </Button>
                  </Col>
                  {child.hasOwnProperty("children") && child.children.length > 0
                    ? child.children.map((nestedChild) => (
                        <React.Fragment>
                          <Col span={6} offset={2}>
                            {nestedChild.name}
                          </Col>
                          <Col span={8}>{nestedChild.type}</Col>
                          <Col span={8}>{nestedChild.code}</Col>
                        </React.Fragment>
                      ))
                    : null}
                </Row>
              </>
            ))
          : null}
        <Row>
          <Col span={8}></Col>
          <Col span={8}>
            <Button onClick={this.appendChild}><MrTranslate id={"ProgrammeCustomInput.add_new"}/></Button>
          </Col>
          <Col span={8}></Col>
        </Row>

        {/* <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            <div>col-6</div>
          </Col>
          <Col className="gutter-row" span={6}>
            <div>col-6</div>
          </Col>
          <Col className="gutter-row" span={6}>
            <div>col-6</div>
          </Col>
          <Col className="gutter-row" span={6}>
            <div>col-6</div>
          </Col>
        </Row>
        <Input.Group size="large">
          <Row gutter={8}>
            {this.state.componentList
              ? this.state.componentList.map((child) => (
                  <>
                    <div>
                      <span></span>
                    </div>
                    {child.name}
                    {child.type}
                    {child.code}
                    <br />
                    {child.children
                      ? child.children.map((nestedChild) => (
                          <React.Fragment>
                            {nestedChild.name}
                            {nestedChild.type}
                            {nestedChild.code}
                          </React.Fragment>
                        ))
                      : null}
                  </>
                ))
              : null}
          </Row>
          <Row>
            <Col span={8}></Col>
            <Col span={8}>
              <Button onClick={this.appendChild}>Add new</Button>
            </Col>
            <Col span={8}></Col>
          </Row>
        </Input.Group> */}
      </>
    );
  }
}

export default ProgrammeCustomInput;
